module.exports = __webpack_public_path__ + "static/media/btn-locked.c1530a5f.svg";